import React, { useContext, useEffect, useState } from "react";
import { useQuery } from "@apollo/client";
import { AuthContext } from "../../../context/AuthProvider";
import { Query, StudyGroup } from "../../../generated/graphqlModels";
import { DASHBOARD_STUDYGROUPS_AND_PINNIGS } from "../../app/pages/queries";
import getStudents from "../helpers/getStudents";
import { fullNameUsernameOrEmail } from "../../../helpers/username";

const useTeacherStudyGroup = () => {
  const user = useContext(AuthContext);
  const [teacherStudyGroups, setTeacherStudyGroups] = useState<StudyGroup[]>([]);
  const [students, setStudents] = useState<any[]>([]);
  const [areStudentsLoaded, setAreStudentsLoaded] = useState(false);

  const { data, loading, error } = useQuery<Query>(DASHBOARD_STUDYGROUPS_AND_PINNIGS, {
    fetchPolicy: 'network-only',
    variables: {
      userId: user?.pk,
      limit: 1000,
      loadPinnings: false,
      customFilters: {
        isSelfLearning: false,
        isExplore: false,
        isChallenge: true,
        fieldsOrFilter: user?.flags.includes('only-related-classes')
          ? {
            fields: [
              {
                field: 'teacher_affiliations__user__id',
                lookup: { iExact: user?.pk },
              },
            ],
          }
          : undefined,
      },
    },
    // when signed out, user will be { is_authenticated: false }
    skip: user == null || user.pk == null,
  });

  useEffect(() => {
    if (data?.studyGroups?.length) {
      const activeTeacherStudyGroups = data.studyGroups
        .filter(
          (studyGroup: StudyGroup) =>
            new Date(studyGroup.license.period.lastDate) > new Date(),
        )
        .map((studyGroup: StudyGroup) => studyGroup.id);

      setTeacherStudyGroups(activeTeacherStudyGroups);

      const fetchStudentsFromStudyGroup = (id: string) => {
        return new Promise((resolve) => resolve(getStudents(id)));
      };

      const studentFetchPromises = activeTeacherStudyGroups.map(
        fetchStudentsFromStudyGroup,
      );

      Promise.all(studentFetchPromises).then((students) => {
        // console.log({students, activeTeacherStudyGroups})
        setStudents(
          students
            .flat()
            .filter((s: any) => fullNameUsernameOrEmail(s) !== '[deleted]'),
        );
        setAreStudentsLoaded(true);
      });

    }
  }, [data]);

  return {
    teacherStudyGroups,
    students,
    areStudentsLoaded,
    loading,
    error
  };
};

export default useTeacherStudyGroup;
